/* Maison du Bebè — nuovo stile: caroselli, aggiunta rapida, filtri collezione. */
(function () {
  'use strict';

  /* ---------- caroselli ---------- */
  function wireRail(scope) {
    scope.querySelectorAll('[data-bl-rail]').forEach(function (wrap) {
      if (wrap.__blRail) return;
      wrap.__blRail = true;
      var rail = wrap.querySelector('.bl-rail');
      var btns = wrap.querySelectorAll('.bl-arrow');
      if (!rail || btns.length < 2) return;
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        btns[0].disabled = rail.scrollLeft <= 2;
        btns[1].disabled = rail.scrollLeft >= max;
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var li = rail.querySelector('li');
          var step = li ? li.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: step * Number(b.dataset.dir || 1), behavior: 'smooth' });
        });
      });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* ---------- toast ---------- */
  var toast, toastText, timer;
  function ensureToast() {
    if (toast) return;
    toast = document.createElement('div');
    toast.className = 'bl-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toastText = document.createElement('span');
    var a = document.createElement('a');
    a.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    a.textContent = 'Vai al carrello';
    toast.appendChild(toastText);
    toast.appendChild(a);
    document.body.appendChild(toast);
  }
  function showToast(msg, isError) {
    ensureToast();
    toastText.textContent = msg;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-open');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.classList.remove('is-open'); }, 5000);
  }

  /* ---------- aggiorna il carrello di Horizon ----------
     Horizon ascolta 'cart:update' e legge event.detail = { resource, sourceId, data: { itemCount, source } }
     (stessa forma di CartUpdateEvent in @theme/events). Con il dettaglio completo il pallino
     del carrello si aggiorna senza errori. Se qualcosa va storto, ripiega su 'cart:refresh'. */
  function syncCart(root) {
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'bl-quick-add', data: { itemCount: cart.item_count, source: 'bl-quick-add' } }
        }));
      })
      .catch(function () {
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (err) {}
      });
  }

  /* ---------- aggiunta rapida (delegata, una volta sola) ---------- */
  if (!window.__blQuickAdd) {
    window.__blQuickAdd = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bl-add[data-variant]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
      var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.description) || 'Errore');
          showToast((btn.dataset.title || 'Prodotto') + ' aggiunto al carrello.');
          btn.classList.add('is-done');
          btn.textContent = 'Aggiunto';
          syncCart(root);
          setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2500);
        })
        .catch(function (err) {
          showToast(err.message || 'Non è stato possibile aggiungere il prodotto.', true);
          btn.textContent = label;
          btn.disabled = false;
        });
    });
  }

  /* ---------- filtri collezione ---------- */
  function wireFilters(scope) {
    scope.querySelectorAll('[data-bl-filters]').forEach(function (form) {
      if (form.__blF) return;
      form.__blF = true;
      // checkbox e select: invio immediato
      var send = function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); };
      // nel cassetto (mobile/tablet) si scelgono più filtri e si applica con "Mostra i risultati"
      var inDrawer = function () { return !!(form.closest('.bl-filters') && window.matchMedia('(max-width: 989px)').matches); };
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"]') && !inDrawer()) send();
      });
      // prezzo: invio con Invio o all'uscita dal campo se cambiato
      form.querySelectorAll('input[type="number"]').forEach(function (inp) {
        var start = inp.value;
        inp.addEventListener('blur', function () { if (inp.value !== start && !inDrawer()) send(); });
      });
      // i campi vuoti non vanno nell'URL
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (inp) { if (inp.value === '') inp.disabled = true; });
      });
    });
    // cassetto filtri su mobile
    function backdropFor(d) { return document.querySelector('.bl-filters__backdrop[aria-controls="' + d.id + '"]'); }
    function closeDrawer(d) {
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      var bd = backdropFor(d); if (bd) bd.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('bl-filters-open');
      var opener = document.querySelector('[data-bl-drawer-open][aria-controls="' + d.id + '"]');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    }
    scope.querySelectorAll('[data-bl-drawer-open]').forEach(function (b) {
      if (b.__blD) return; b.__blD = true;
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('aria-controls'));
        if (!d) return;
        d.classList.add('is-open');
        var bd = backdropFor(d); if (bd) bd.classList.add('is-open');
        b.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.classList.add('bl-filters-open');
        var close = d.querySelector('[data-bl-drawer-close]');
        if (close) close.focus();
      });
    });
    scope.querySelectorAll('[data-bl-drawer-close]').forEach(function (b) {
      if (b.__blD) return; b.__blD = true;
      b.addEventListener('click', function () {
        closeDrawer(b.closest('.bl-filters') || document.getElementById(b.getAttribute('aria-controls')));
      });
    });
    if (!window.__blDrawerEsc) {
      window.__blDrawerEsc = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') document.querySelectorAll('.bl-filters.is-open').forEach(closeDrawer);
      });
    }
  }

  /* ordinamento: la select sta fuori dal form (attributo form=) */
  if (!window.__blSort) {
    window.__blSort = true;
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-bl-sort]');
      if (!sel) return;
      var form = document.getElementById(sel.getAttribute('form'));
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      else { var u = new URL(sel.dataset.url, location.origin); u.searchParams.set('sort_by', sel.value); location.href = u.toString(); }
    });
  }

  function init(scope) {
    scope = scope || document;
    wireRail(scope);
    wireFilters(scope);
  }

  window.blInit = init; /* usato dalle sezioni caricate dopo la pagina (es. Consigliati) */

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
